import React from 'react';

const NEW_SITE_URL = 'https://www.itips.blue/en/';

const NewSiteLink: React.FC = () => (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#ffffff',
      margin: 0,
      padding: '24px',
    }}
  >
    <a
      href={NEW_SITE_URL}
      style={{
        fontSize: '1.5rem',
        color: '#0066cc',
        textDecoration: 'underline',
        fontFamily: '"Noto Sans", sans-serif',
      }}
    >
      New website is here →
    </a>
  </div>
);

export default NewSiteLink;
